module.exports = __webpack_public_path__ + "img/bwg_mac.8ba07374.png";